module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.certificateNumber) ? _c('div', {
    staticClass: "data"
  }, [_c('img', {
    staticClass: "data__image",
    attrs: {
      "src": require("./images/certificate.png"),
      "alt": "Сертификат"
    }
  }), _c('div', {
    staticClass: "data__info"
  }, [(_vm.childName) ? _c('TextBlock', {
    attrs: {
      "title": "Вы получили сертификат на имя"
    }
  }, [_vm._v(_vm._s(_vm.childName))]) : _vm._e(), (_vm.certificateNumber) ? _c('TextBlock', {
    attrs: {
      "title": "Сертификат №:",
      "infoText": "(сертификат не активирован)",
      "info": _vm.isSertificateConfirmed
    }
  }, [_vm._v(_vm._s(_vm.certificateNumber))]) : _vm._e(), (_vm.certificateDateEnd) ? _c('TextBlock', {
    attrs: {
      "title": "Действителен до:"
    }
  }, [_vm._v(_vm._s(_vm.certificateDateEnd))]) : _vm._e()], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4822fea7","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/certificate/components/data/Data.vue
// module id = 83d6c16d40d8f9e7b823
// module chunks = 9